var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerBody"},[_c('ul',[_c('li',[_c('span',{on:{"click":_vm.goHome}},[_vm._v("Suezp小站")])]),_c('li',[_c('span',{on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.isLoginSpace?'退出登入':'登入'))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }